import React from 'react';

import { Table } from 'react-bootstrap';
import moment from 'moment';

import { CDT } from '../../../infrastructure/constants/common';
import { isMobileResolution } from '../../../infrastructure/utils/common';
import Checkboxes from '../../utils/FormWidgets/Checkboxes';
import { ProductReview } from '../../../types/ProductReview';

import ActivitiesRnRMobile from './ActivitiesRnRMobile';

type Props = {
  content: ProductReview[];
  onFeaturedChange(item: ProductReview): void;
  onUserIdClick(id: string): void;
  setReviewToResponse(item: ProductReview): void;
  setReviewToChangeVisibility(item: ProductReview): void;
};

const ActivitiesRnR = ({
  content = [],
  onFeaturedChange,
  onUserIdClick,
  setReviewToResponse,
  setReviewToChangeVisibility,
}: Props) => {
  const getFormattedDateSubmitted = item =>
    moment(item.createdAt).tz(CDT).format('MM/DD/YY hh:mm A z');

  if (isMobileResolution()) {
    return (
      <ActivitiesRnRMobile
        content={content}
        getFormattedDateSubmitted={getFormattedDateSubmitted}
        onFeaturedChange={onFeaturedChange}
      />
    );
  }

  const onRespondClick = (event, review) => {
    event.stopPropagation();
    setReviewToResponse(review);
  };

  const onChangeVisibilityClick = (event, review) => {
    event.stopPropagation();
    setReviewToChangeVisibility(review);
  };

  const renderItem = (item: ProductReview) => (
    <tr key={item.createdAt + item.userId}>
      <td>
        {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          <Checkboxes
            onChange={() => onFeaturedChange(item)}
            options={[{ value: item.userId, label: item.userId }]}
            values={item.featured ? [item.userId] : []}
            noLabel
          />
        }
      </td>
      <td>{item.rating}</td>
      <td>{item.review}</td>
      <td>{item.vendorReview}</td>
      <td className='clickable' onClick={() => onUserIdClick(item.userId)}>
        {item.userId}
      </td>
      <td>{getFormattedDateSubmitted(item)}</td>
      <td>
        <button
          type='button'
          className={
            item.adminResponse ? 'btn btn-secondary' : 'btn btn-primary'
          }
          onClick={event => onRespondClick(event, item)}
        >
          {item.adminResponse ? 'Edit' : 'Respond'}
        </button>
      </td>
      <td>
        <button
          type='button'
          className='btn btn-primary'
          onClick={event => onChangeVisibilityClick(event, item)}
        >
          {item.hidden ? 'Show Review' : 'Hide Review'}
        </button>
      </td>
    </tr>
  );

  return (
    <div>
      <Table hover>
        <thead>
          <tr>
            <th>Featured</th>
            <th>Rating</th>
            <th>Review</th>
            <th>Vendor Feedback</th>
            <th>User ID</th>
            <th>Date Submitted</th>
            <th />
            <th />
          </tr>
        </thead>
        <tbody>{content.map(renderItem)}</tbody>
      </Table>
    </div>
  );
};

export default React.memo(ActivitiesRnR);
